import { useEffect, useMemo, useState } from "react";
import { getElectores } from "../Api/ApiMetodo";

// Votantes del registro como opciones { value, label } para SelectComponent.
// El backend ya limita al digitador a sus propios votantes.
// (los líderes están en useLideres: se listan todos, no solo los propios)
const useOpcionesElectores = () => {
  const [electores, setElectores] = useState([]);

  useEffect(() => {
    getElectores()
      .then((response) => setElectores(response?.data?.electores ?? []))
      .catch((error) => console.error(error));
  }, []);

  const opcionesVotante = useMemo(
    () =>
      [...electores]
        .sort((a, b) => `${a.nombres} ${a.apellidos}`.localeCompare(`${b.nombres} ${b.apellidos}`))
        .map((e) => ({ value: e.id, label: `${e.nombres} ${e.apellidos} · CC ${e.cedula}` })),
    [electores]
  );

  return { opcionesVotante };
};

export default useOpcionesElectores;
